import React from 'react'
import Layout from '../components/layout'
import { Link, graphql } from 'gatsby'
import { css } from "@emotion/core"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
//import Head from '../components/head'
import Metatags from '../components/metatag';

import projectStyles from '../styles/project.module.scss'

import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from 'styled-components'
import SliderArrow from '../components/SliderArrow'
import { IoIosArrowRoundDown } from "react-icons/io";



const Wrapper = styled.div`

    width: 80%;
    padding: 32px;
    background-color: inherit;
    color: black;
    margin: 0 auto;
`
const Wrapper2 = styled.div`

    width: 90%;
    background-color: inherit;
    color: black;
    margin: 0 auto;
`

export const query = graphql`
query($slug: String!) {
    contentfulPortfolio(slug: { eq: $slug }) {
        slug
        projectTitle
        subtituloProyecto
        typeOfProject
        projectSummary
        metaDescription
        services
        websiteName
        websiteLink
        date(formatString:"MMMM Do, YYYY")
        body {
            json
        }
        heroImage {
            fluid(maxWidth: 1200, maxHeight: 725) {
            src
            }
        }
        sliderLogo{
            fluid{
              src
            }
        }
        imagenSlider1{
            fluid{
              src
            }
        }
        imagenSlider2{
            fluid{
              src
            }
        }
        imagenSlider3{
            fluid{
              src
            }
        }
        imagenSlider21{
            fluid(maxWidth: 1500, maxHeight: 906, quality: 100){
              src
            }
        }
        imagenSlider22{
            fluid(maxWidth: 1500, maxHeight: 906, quality: 100){
              src
            }
        }
        imagenSlider23{
            fluid(maxWidth: 1500, maxHeight: 906, quality: 100){
              src
            }
        }
        imagenSlider24{
            fluid(maxWidth: 1500, maxHeight: 906, quality: 100){
              src
            }
        }
    }

    site {
        siteMetadata {
            siteUrl
            title
          }
       }
  }
`


const Project = props => {

    const options = {
        renderNode: {
            "embedded-asset-block": (node) => {
                const alt = node.data.target.fields.title['en-US']
                const url = node.data.target.fields.file['en-US'].url
                return <img alt={alt} src={url}/>
            }
        }
      }

      const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        nextArrow: <SliderArrow to="next" />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1,
                dots: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            }
          ]
      };

      const settings2 = {
        dots: false,
        infinite: true,
        speed: 500,
        nextArrow: <SliderArrow to="next" />,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1,
                dots: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                nextArrow: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            }
          ]
      };
    
    const slugsite = props.data.contentfulPortfolio.slug

    return (
        <Layout>
            <Metatags
                title={`${props.data.contentfulPortfolio.projectTitle} | ${props.data.site.siteMetadata.title}`}
                description={props.data.contentfulPortfolio.metaDescription}
                thumbnail={`https:${props.data.contentfulPortfolio.heroImage.fluid.src}`}
                url= {`${props.data.site.siteMetadata.siteUrl}/portfolio/`}
                pathname={slugsite}
            />
            <section className={projectStyles.header_wrapper}>

                <div className={projectStyles.header_wrapper_box}> 

                    <div className={projectStyles.header_wrapper_box_text}>

                        <h3 className={projectStyles.header_wrapper_box_text_title}>{props.data.contentfulPortfolio.typeOfProject}</h3>
                        <h1 className={projectStyles.header_wrapper_box_text_main}>
                            {props.data.contentfulPortfolio.projectTitle}
                        </h1>

                        
                    </div>
                    <div className={projectStyles.header_wrapper_box_image}>

                        <img src={props.data.contentfulPortfolio.heroImage.fluid.src} alt={props.data.contentfulPortfolio.projectTitle} css={css`

                            width: 100%;

                            @media (max-width:1200px){
                                width: 70%;
                            }

                            @media (max-width:500px){
                                width: 100%;
                            }

                        `} loading="lazy"/>
                        
                    </div>
                    
                </div>
                
                <div className={projectStyles.header_wrapper_box2}>

                    <div className={projectStyles.header_wrapper_box2_left}>
                        <Link to={`/portfolio/${props.data.contentfulPortfolio.slug}/#projects` } className="btn btn__white btn__animated">Ver Proyecto</Link>
                    </div>

                </div>

            </section>

            <section className={projectStyles.main} id='projects'>

                <div className={projectStyles.summary}>
                    <div className={projectStyles.summary_wrapper}>

                        <div className={projectStyles.summary_wrapper_left}>
                            <h2>{props.data.contentfulPortfolio.projectTitle}</h2>
                            <p>{props.data.contentfulPortfolio.projectSummary}</p>
                        </div>

                        <div className={projectStyles.summary_wrapper_right}>
                            
                            <div className={projectStyles.summary_wrapper_right_services}>
                                <h3>Servicios</h3>
                                <p>{props.data.contentfulPortfolio.services}</p>
                            </div>
                            <div className={projectStyles.summary_wrapper_right_technology}>
                                <h3>Visitar web</h3>
                                <a href={props.data.contentfulPortfolio.websiteLink} target='_blank' rel="noopener noreferrer">
                                    {props.data.contentfulPortfolio.websiteName}
                                    <IoIosArrowRoundDown className={projectStyles.summary_wrapper_right_arrow} />
                                </a>
                            </div>

                        </div>

                    </div>
                </div>

                <div className={projectStyles.slider}>
                    <Wrapper>
                        <div>
                        <Slider {...settings}>
                            <div>
                                <img src={props.data.contentfulPortfolio.sliderLogo.fluid.src} alt='prueba' css={css`
                                width: 90%;
                                margin: 10px;
                                padding: 2%;
                                margin: 0 auto;
                                border-radius: 1em;
                                `} loading="lazy"/>
                            </div>
                            <div>
                                <img src={props.data.contentfulPortfolio.imagenSlider1.fluid.src} alt='prueba' css={css`
                                width: 90%;
                                margin: 10px;
                                padding: 2%;
                                margin: 0 auto;
                                border-radius: 1em;
                                `} loading="lazy"/>
                            </div>
                            <div>
                                <img src={props.data.contentfulPortfolio.imagenSlider2.fluid.src} alt='prueba' css={css`
                                width: 90%;
                                margin: 10px;
                                padding: 2%;
                                margin: 0 auto;
                                border-radius: 1em;
                                `} loading="lazy"/>
                            
                            </div>
                            <div>
                                <img src={props.data.contentfulPortfolio.imagenSlider3.fluid.src} alt='prueba' css={css`
                                width: 90%;
                                margin: 10px;
                                padding: 2%;
                                margin: 0 auto;
                                border-radius: 1em;
                                `} loading="lazy"/>
                            
                            </div>
                            
                        </Slider>
                        </div>
                    </Wrapper>
                </div>


                <div className={projectStyles.main_body_wrapper}>

                    {documentToReactComponents(props.data.contentfulPortfolio.body.json, options)}

                </div>
            
            </section>

            <section className={projectStyles.slider2}>

                <div className={projectStyles.slider2_wrapper}>

                <Wrapper2>
                        <div>
                        <Slider {...settings2}>
                            <div>
                                <img src={props.data.contentfulPortfolio.imagenSlider21.fluid.src} alt='prueba' css={css`
                                width: 90%;
                                margin: 10px;
                                padding: 2%;
                                
                                `}/>
                            </div>
                            <div>
                                <img src={props.data.contentfulPortfolio.imagenSlider22.fluid.src} alt='prueba' css={css`
                                width: 90%;
                                margin: 10px;
                                padding: 2%;
                                
                                `}/>
                            </div>
                            <div>
                                <img src={props.data.contentfulPortfolio.imagenSlider23.fluid.src} alt='prueba' css={css`
                                width: 90%;
                                margin: 10px;
                                padding: 2%;
                               
                                `}/>
                            
                            </div>
                            <div>
                                <img src={props.data.contentfulPortfolio.imagenSlider24.fluid.src} alt='prueba' css={css`
                                width: 90%;
                                margin: 10px;
                                padding: 2%;
                                
                                `}/>
                            
                            </div>
                            
                        </Slider>

                            <div css={css`width: 100%; display: flex; justify-content: center; margin-bottom: 2rem;`}>
                                <Link to={`/portfolio`} className="btn btn__white btn__animated" css={css`

                                    @media (max-width:1000px){
                                        margin-top: 4rem;
                                    }

                                    @media (max-width:500px){
                                        padding: 0.5rem 1rem !important;
                                    }
                                
                                `}><IoIosArrowRoundDown css={css`transform: rotate(90deg); font-size: 2rem; vertical-align: middle;`}/>Volver al Portfolio</Link>
                            </div>

                        </div>
                    </Wrapper2>

                </div>

            </section>
        </Layout>
    )

}

export default Project